<template>
  <el-form ref="form" :model="form" label-width="80px">
    <el-form-item label="课件名称">
      <el-input
        v-model="form.name"
        maxlength="100"
        placeholder="最长可输入100字"
      ></el-input>
    </el-form-item>
    <el-form-item label="知识点">
      <el-select
        v-model="form.knows"
        placeholder="请选择"
        :disabled="ifChecks"
        clearable
        filterable
      >
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.knowledgeName"
          :value="item.id"
        >
          {{ item.knowledgeName }}
        </el-option>
        <div
          @click="getList(courseWareId)"
          v-show="more"
          style="
            text-align: center;
            font-size: 12px;
            color: #ccc;
            padding: 5px 0;
            cursor: pointer;
          "
        >
          点击更多
        </div>
      </el-select>
    </el-form-item>
    <el-form-item label="类型">
      <el-radio-group
        v-model="form.radio"
        @change="chooseModel"
        :disabled="ifChecks"
      >
        <el-radio :label="1">视频</el-radio>
        <el-radio :label="2">音频</el-radio>
        <el-radio :label="4">文档</el-radio>
        <el-radio :label="3">文本</el-radio>
        <el-radio :label="5">音视频链接</el-radio>
      </el-radio-group>
      <el-input v-model="links" v-if="showLinks"></el-input>
      <el-upload
        class="upload-demo"
        :action="url + '/zkfz/file/addUploadFile'"
        :before-upload="beforeUpload"
        :on-success="successUp"
        :on-error="errorUp"
        :on-change="handleChange"
        :on-remove="removeFile"
        :on-preview="handlePreviewUpload"
        :file-list="form.fileList"
      >
        <el-button size="small" type="primary" v-if="ifUpload"
          >点击上传</el-button
        >
      </el-upload>
    </el-form-item>
    <el-row>
      <el-col :span="12">
        <el-form-item label="时长" v-if="ifDurations">
          <el-time-picker
            :disabled="form.radio != '5' && ifChecks"
            v-model="durations"
            :picker-options="{}"
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            placeholder="请输入时长"
          >
          </el-time-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12" :push="form.radio == '4' ? 23 : 11">
        <div class="continuous_input" v-show="isPreview" @click="handlePreview">
          预览
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :push="1">
        <div v-show="isShowAudio">
          <audio :src="fileSrc" preload controls></audio>
        </div>
      </el-col>
      <el-col :span="16" :push="4">
        <div
          class="preview_video"
          v-show="isShowVideo"
          @click.prevent="handleVideo"
        >
          <div class="mask" v-show="isShowMask"></div>
          <video
            ref="video"
            :src="fileSrc"
            style="width: 100%"
            preload
            controls
          ></video>
        </div>
        <div v-show="isShowPDF">
          <object
            :data="fileSrc"
            type="application/pdf"
            width="800"
            height="800"
          >
            This browser does not support PDFs. Please download the PDF to view it: 
            <a :href="fileSrc">Download PDF</a>
          </object>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import * as api from '@/api/courseStructure/courseStructure'
import * as api2 from '@/api/courseware/checkCourseware'
export default {
  props: ['courseWareId', 'institutionId', 'zyVideoId', 'videoDataId'],
  data() {
    return {
      form: {
        name: '',
        knows: '',
        radio: 1,
        fileList: [],
      },
      oldKnowleg: '',
      ifChecks: false,
      options: [],
      more: true,
      showLinks: false,
      ifUpload: true,
      ifDurations: true,
      durations: '',
      page: '',
      knowledgeId: '',
      isPreview: true,
      isShowVideo: false,
      isShowMask: true,
      fileSrc: '',
      isUpload: true,
      links: '',
      fileId: '',
      file: '',
      ifEditTypes: '1',
      downloadId: '',
      isShowAudio: false,
      isShowPDF: false,
    }
  },
  created() {
    this.getList()
    if (this.videoDataId !== '') {
      this.ifChecks = true
      this.ifEditTypes = '2'
      this.downloadId = this.videoDataId
      this.getCoursewareDetail()
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  watch: {
    isShowVideo() {
      if (this.isShowVideo) {
        this.$refs.video.addEventListener('play', this.handlePlay)
        this.$refs.video.addEventListener('pause', this.handlePause)
      } else {
        this.$refs.video.removeEventListener('play', this.handlePlay)
        this.$refs.video.removeEventListener('pause', this.handlePause)
      }
    },
  },
  methods: {
    getList() {
      this.page++
      api
        .knowLegGetList({
          page: this.page,
          pageSize: 10,
          courseWareId: this.courseWareId,
        })
        .then(({ data }) => {
          data = data.data
          if (data.total < 10) {
            this.more = false
          }
          if (this.page * 10 > data.total) {
            this.more = false
          }
          this.options = [...this.options, ...data.list]
        })
    },
    //获取课件信息
    getCoursewareDetail() {
      api
        .getDetail({ id: this.videoDataId, courseWareId: this.courseWareId })
        .then(({ data }) => {
          data = data.data
          // this.form.name = data.title
          this.form.knows = data.knowledgeName //由于分页请求回来的数据中id无法匹配到对应的名字
          this.oldKnowleg = data.knowledgeName //保留初始值来对比
          this.knowledgeId = data.knowledgeId //如果没有改动知识点,利用这个id重新赋值
          if (data.type == null || data.type == undefined || data.type == '') {
          } else {
            // this.ifLocations = true // 改为查看不可编辑
            this.form.radio = data.type
            if (
              this.form.radio == '1' ||
              this.form.radio == '2' ||
              this.form.radio == '4'
            ) {
              this.isPreview = true
            } else {
              this.isPreview = false
            }
            if (this.form.radio == '5') {
              this.showLinks = true
              // this.links = data.videoAddress
              this.ifDurations = true
              this.ifUpload = false
              // this.durations = this.secondsFormat(data.duration)
            } else if (this.form.radio == '1' || this.form.radio == '2') {
              this.showLinks = false
              this.ifDurations = true
              this.ifUpload = true
              // this.durations = this.secondsFormat(data.duration)
              // this.form.fileList.push({ name: data.fileName, url: data.url })
            } else {
              this.showLinks = false
              this.ifDurations = false
              this.ifUpload = true
              // this.form.fileList.push({ name: data.fileName, url: data.url })
            }
            this.locationShow = true
          }
        })
    },
    // 秒转时分秒
    secondsFormat(value) {
      var secondTime = parseInt(value) // 秒
      var minuteTime = 0 // 分
      var hourTime = 0 // 小时
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60)
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result =
        '' +
        (parseInt(secondTime) < 10
          ? '0' + parseInt(secondTime)
          : parseInt(secondTime))

      // if (minuteTime > 0) {
      result =
        '' +
        (parseInt(minuteTime) < 10
          ? '0' + parseInt(minuteTime)
          : parseInt(minuteTime)) +
        ':' +
        result
      // }
      // if (hourTime > 0) {
      result =
        '' +
        (parseInt(hourTime) < 10
          ? '0' + parseInt(hourTime)
          : parseInt(hourTime)) +
        ':' +
        result
      // }
      return result
    },
    chooseModel() {
      this.form.fileList = []
      this.durations = ''
      if (
        this.form.radio == '1' ||
        this.form.radio == '2' ||
        this.form.radio == '4'
      ) {
        this.isPreview = true
      } else {
        this.isPreview = false
      }
      if (this.form.radio == '5') {
        this.showLinks = true
        this.ifDurations = true
        this.ifUpload = false
      } else if (this.form.radio == '1' || this.form.radio == '2') {
        this.showLinks = false
        this.ifDurations = true
        this.ifUpload = true
      } else {
        this.showLinks = false
        this.ifDurations = false
        this.ifUpload = true
      }
    },
    getDuration(file) {
      var binaryData = []
      // 传入file
      binaryData.push(file)
      //获取视频或者音频时长
      var fileurl = URL.createObjectURL(
        new Blob(binaryData, { type: 'application/zip' })
      )
      //经测试，发现audio也可获取视频的时长
      var audioElement = new Audio(fileurl)
      var duration = ''
      audioElement.addEventListener('loadedmetadata', (_event) => {
        duration = audioElement.duration
        this.durations = this.times(duration)
      })
      return duration
    },
    times(data) {
      var time = Number(data)
      var h = Math.floor(time / 3600)
      var m = Math.floor((time % 3600) / 60)
      var s = parseInt(time % 3600) % 60
      var hh = h < 10 ? '0' + h : h
      var mm = m < 10 ? '0' + m : m
      var ss = s < 10 ? '0' + s : s
      return hh + ':' + mm + ':' + ss
    },
    async beforeUpload(file) {
      this.isUpload = false
      if (this.form.radio == '1') {
        //视频
        const isJPG = file.type === 'video/mp4'
        const isLt2M = file.size / 1024 / 1024 < 1024 * 3 //3G

        if (!isJPG) {
          return this.$message.error('上传文件只能是 mp4 类型!')
        }
        if (!isLt2M) {
          return this.$message.error('上传文件大小不能超过 3G!')
        }
        // return isJPG && isLt2M
        await this.getDuration(file)
        return (this.isUpload = true)
      } else if (this.form.radio == '2') {
        //音频
        const isJPG = file.type === 'audio/mpeg'
        const isLt2M = file.size / 1024 / 1024 < 1024

        if (!isJPG) {
          return this.$message.error('上传文件只能是 mp3 类型!')
        }
        if (!isLt2M) {
          return this.$message.error('上传文件大小不能超过 1G!')
        }
        // return isJPG && isLt2M
        await this.getDuration(file)
        return (this.isUpload = true)
      } else if (this.form.radio == '4') {
        //文档
        // const fileType = [
        //   'application/pdf',
        //   'application/msword',
        //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        //   'application/vnd.ms-powerpoint',
        //   'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        //   'application/vnd.ms-excel',
        //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        // ]
        const isJPG = file.type == 'application/pdf'
        // const isJPG = fileType.includes(file.type)
        const isLt2M = file.size / 1024 / 1024 < 1024

        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 1G!')
          return false
        }
        if (!isJPG) {
          this.$message.error('上传文件只能是 pdf 类型!')
          return false
        }
        // return isLt2M && isJPG
        return (this.isUpload = true)
      } else if (this.form.radio == '3') {
        //文本
        const isJPG = file.type === 'text/plain'
        const isLt2M = file.size / 1024 / 1024 < 1024

        if (!isJPG) {
          return this.$message.error('上传文件只能是 txt 类型!')
        }
        if (!isLt2M) {
          return this.$message.error('上传文件大小不能超过 1G!')
        }
        // return isJPG && isLt2M
        return (this.isUpload = true)
      }
    },
    successUp(res, file, fileList) {
      let formdata = new FormData()
      formdata.append('file', file.raw)
      if (res.code === 100000) {
        this.fileId = res.data
        api2.beforeSaveUpload(res.data).then(({ data }) => {
          this.fileSrc = data.data.url
          this.form.fileList = []
          this.form.fileList.push({
            name: fileList[0].name,
            url: data.data.url,
          })
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    errorUp(err, file, fileList) {
      this.isUpload = false
      return this.$message.error(err)
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.file = file.raw
    },
    removeFile() {
      this.isUpload = false
      this.fileSrc = ''
      this.isShowAudio = false
      this.isShowVideo = false
      this.isShowPDF = false
      this.durations = ''
    },
    handlePreviewUpload(file) {
      if (this.downloadId === '') {
        window.open(file.url)
      } else {
        window.open(
          this.url + '/zkfz/elZyVideoSection/getFile?id=' + this.downloadId
        )
      }
    },
    handlePreview() {
      if (this.form.radio == '1') {
        this.isShowVideo = !this.isShowVideo
      } else if (this.form.radio == '2') {
        this.isShowAudio = !this.isShowAudio
      } else if (this.form.radio == '4') {
        this.isShowPDF = !this.isShowPDF
      }
    },
    handleVideo() {
      if (this.isPlay) {
        this.isShowMask = true
        this.$refs.video.pause()
        this.isPlay = false
      } else {
        this.isShowMask = false
        this.$refs.video.play()
        this.isPlay = true
      }
    },
    handlePlay() {
      this.isPlay = true
      this.isShowMask = false
    },
    handlePause() {
      this.isPlay = false
      this.isShowMask = true
    },
    // 时分秒转秒
    toS(time) {
      let times = time.split(':')
      let second = times.length > 0 ? parseInt(times.pop()) : 0
      if (second >= 60) throw Error('格式不正确')
      let minute = times.length > 0 ? parseInt(times.pop()) : 0
      if (minute >= 60) throw Error('格式不正确')
      let hour = times.length > 0 ? parseInt(times.pop()) : 0
      if (hour >= 24) throw Error('格式不正确')

      let secondCount = hour * 3600
      secondCount += minute * 60
      secondCount += second
      return secondCount
    },
    save() {
      if (this.form.radio != '5') {
        if (this.file === '') {
          return this.$message.error('需要上传附件')
        }
      } else {
        if (this.links === '') {
          return this.$message.error('请填写音视频链接')
        }
      }
      if (!this.isUpload) return this.$message.error('请上传正确的文件后保存')

      if (this.form.radio == '5') {
        if (
          this.durations == '' ||
          this.durations == null ||
          this.durations == undefined
        ) {
          this.$message({ type: 'error', message: '请选择时长' })
          return false
        }
      }
      if (!this.form.name) {
        this.$message({ type: 'error', message: '请输入名称' })
      }
      //  else if (!this.form.knows) {
      //   this.$message({ type: 'error', message: '请选择知识点' })
      // }
      else {
        this.$parent.$parent.submitForm()
      }
    },
    appendChild(zyVideoSectionId) {
      let formdata = new FormData()
      // if (this.ifEditTypes == '2') {
      //   formdata.append('id', this.downloadId)
      // }
      formdata.append('uid', this.getUId)
      formdata.append('title', this.form.name)
      formdata.append('ctime', Date.parse(new Date()) / 1000)
      formdata.append('institutionId', this.institutionId)
      formdata.append('zyVideoId', this.zyVideoId)
      // formdata.append('knowledgeId',this.knowledgeId)
      if (this.form.knows === this.oldKnowleg) {
        this.form.knows = this.knowledgeId
      }
      formdata.append('knowledgeId', this.form.knows)
      formdata.append('type', this.form.radio)
      if (this.form.radio == '5') {
        formdata.append('videoAddress', this.links)
      } else {
        // formdata.append('file', this.file)
        formdata.append('fileId', this.fileId)
      }
      if (
        this.form.radio == '1' ||
        this.form.radio == '2' ||
        this.form.radio == '5'
      ) {
        formdata.append('duration', this.toS(this.durations))
      }
      formdata.append('zyVideoSectionId', zyVideoSectionId)
      api.updateVideoData(formdata).then(({ data }) => {
        // data = data.data
        if (data.code == 100000) {
          this.$emit('endSave')
          this.$message({ type: 'success', message: data.msg })
        } else {
          this.$message({ type: 'error', message: data.msg })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.continuous_input {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 70px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background-color: #529fff;
  border-radius: 4px;
  cursor: pointer;
}
.preview_video {
  position: relative;
  .mask {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    content: '';
    width: 0;
    height: 0;
    border-top: 30px solid transparent;
    border-left: 60px solid #000;
    border-bottom: 30px solid transparent;
    z-index: 6;
  }
}
*::-webkit-media-controls-overlay-play-button {
  display: none !important;
  -webkit-appearance: none;
}
</style>